import {
	buildQueryString,
	getRoutePath
} from '@sporkbytes/routing';

const entityPathSegment = "meal-proposals";
function sendCorrection(axios, id, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "correction", "send"]
	};

	const routePath = getRoutePath(config);

	return axios.post(routePath, body)
		.then(response => response.data);
}
function findDriverSchedules(axios, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: ["find-driver-schedules"]
	};

	const routePath = getRoutePath(config);

	return axios.post(routePath, body)
		.then(response => response.data);
}
function duplicate(axios, id, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "duplicate"]
	};

	const routePath = getRoutePath(config);

	return axios.post(routePath, body)
		.then(response => response.data);
}
function deliver(axios, id, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "deliver"]
	};

	const routePath = getRoutePath(config);

	return axios.put(routePath, body)
		.then(response => response.data);
}
function requestClientApproval(axios, id, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "client", "approval", "request"]
	};

	const routePath = getRoutePath(config);

	return axios.post(routePath, body)
		.then(response => response.data);
}
function requestClientConfirmation(axios, id, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "client", "confirmation", "request"]
	};

	const routePath = getRoutePath(config);

	return axios.post(routePath, body)
		.then(response => response.data);
}
function approve(axios, id, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "approve"]
	};

	const routePath = getRoutePath(config);

	return axios.put(routePath, body)
		.then(response => response.data);
}
function disapprove(axios, id, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "disapprove"]
	};

	const routePath = getRoutePath(config);

	return axios.put(routePath, body)
		.then(response => response.data);
}
function cancel(axios, id, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "cancel"]
	};

	const routePath = getRoutePath(config);

	return axios.put(routePath, body)
		.then(response => response.data);
}
function sendClientCancellationNotice(axios, id, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "client", "cancellation-notice", "send"]
	};

	const routePath = getRoutePath(config);

	return axios.post(routePath, body)
		.then(response => response.data);
}
function getAll(axios, queryStringConfig) {
	const config = {
		entityPathSegment,
		queryString: buildQueryString(queryStringConfig)
	};

	const routePath = getRoutePath(config);

	return axios.get(routePath)
		.then(response => response.data);
}
function get(axios, id, queryStringConfig) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id],
		queryString: buildQueryString(queryStringConfig)
	};

	const routePath = getRoutePath(config);

	return axios.get(routePath)
		.then(response => response.data);
}
function post(axios, body) {
	const config = {
		entityPathSegment
	};

	const routePath = getRoutePath(config);

	return axios.post(routePath, body)
		.then(response => response.data);
}
function put(axios, id, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id]
	};

	const routePath = getRoutePath(config);

	return axios.put(routePath, body)
		.then(response => response.data);
}
function addExistingContact(axios, id, ContactId, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "contacts", ContactId]
	};

	const routePath = getRoutePath(config);

	return axios.post(routePath, body)
		.then(response => response.data);
}
function addNewContact(axios, id, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "contacts"]
	};

	const routePath = getRoutePath(config);

	return axios.post(routePath, body)
		.then(response => response.data);
}
function removeContact(axios, id, ContactId, queryStringConfig) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "contacts", ContactId],
		queryString: buildQueryString(queryStringConfig)
	};

	const routePath = getRoutePath(config);

	return axios.delete(routePath)
		.then(response => response.data);
}
function getDeliveryDrivers(axios, id, queryStringConfig) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "delivery-drivers"],
		queryString: buildQueryString(queryStringConfig)
	};

	const routePath = getRoutePath(config);

	return axios.get(routePath)
		.then(response => response.data);
}
function setDeliveryDrivers(axios, id, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "delivery-drivers"]
	};

	const routePath = getRoutePath(config);

	return axios.put(routePath, body)
		.then(response => response.data);
}
function getDeliveryGear(axios, id, queryStringConfig) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "delivery-gear"],
		queryString: buildQueryString(queryStringConfig)
	};

	const routePath = getRoutePath(config);

	return axios.get(routePath)
		.then(response => response.data);
}
function setDeliveryGear(axios, id, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "delivery-gear"]
	};

	const routePath = getRoutePath(config);

	return axios.put(routePath, body)
		.then(response => response.data);
}
function setMealCategories(axios, id, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "meal-categories"]
	};

	const routePath = getRoutePath(config);

	return axios.put(routePath, body)
		.then(response => response.data);
}
function createSporkContact(axios, id, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "spork-contacts"]
	};

	const routePath = getRoutePath(config);

	return axios.post(routePath, body)
		.then(response => response.data);
}
function reassignSporkContact(axios, id, SporkContactId, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "spork-contacts", SporkContactId]
	};

	const routePath = getRoutePath(config);

	return axios.put(routePath, body)
		.then(response => response.data);
}
function removeSporkContact(axios, id, queryStringConfig) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "spork-contacts"],
		queryString: buildQueryString(queryStringConfig)
	};

	const routePath = getRoutePath(config);

	return axios.delete(routePath)
		.then(response => response.data);
}
export {
	addExistingContact,
	addNewContact,
	approve,
	cancel,
	createSporkContact,
	deliver,
	disapprove,
	duplicate,
	findDriverSchedules,
	get,
	getAll,
	getDeliveryDrivers,
	getDeliveryGear,
	post,
	put,
	reassignSporkContact,
	removeContact,
	removeSporkContact,
	requestClientApproval,
	requestClientConfirmation,
	sendClientCancellationNotice,
	sendCorrection,
	setDeliveryDrivers,
	setDeliveryGear,
	setMealCategories
};
